<template>
    <div class="product">
        <navBar></navBar>
        <div class="s-banner"></div>
        <div class="p-items">
            <div class="p-item p-item-stu" @click="goPage('ced')">
                <div class="p-text">
                    <h5 class="p-text-title">定制化企业诊断</h5>
                    <p class="p-text-intro">现状分析定制化方案<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-tea" @click="goPage('3s')">
                <div class="p-text">
                    <h5 class="p-text-title">3S教学</h5>
                    <p class="p-text-intro">知识传递与内化<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-p" @click="goPage('teaTrain')">
                <div class="p-text">
                    <h5 class="p-text-title">教师培训</h5>
                    <p class="p-text-intro">教学方法轻松复制<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
            <div class="p-item p-item-s" @click="goPage('operation')">
                <div class="p-text">
                    <h5 class="p-text-title">运营管理</h5>
                    <p class="p-text-intro">管理难点一网打尽<img src="https://restaskimg.civaonline.cn/imagesH5/product/arrow-icon.png" alt=""></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
  methods: {
    // 跳转对应服务页面
    goPage(name) {
      this.$router.push({ name: name });
    },
  },
}
</script>

<style scoped lang="less">
.product{
    .s-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/service/service-banner.png") no-repeat center center / cover;
    }
    .p-items{
        padding: 26px 20px 25px;
        .p-item{
            margin-bottom: 8px;
            width: 100%;
            height: 224px;
            background: url("https://restaskimg.civaonline.cn/imagesH5/service/ced-s.png") no-repeat center center / cover;
        }
        .p-item-tea{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/3s-s.png");
        }
        .p-item-p{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/tea-s.png");
        }
        .p-item-s{
            background-image: url("https://restaskimg.civaonline.cn/imagesH5/service/opera-s.png");
        }
        .p-text{
            color: #FFFFFF;
            font-family: SyMedium;
            margin-left: 60px;
            padding-top: 52px;
        }
        .p-text-title{
            font-size: 42px;
            line-height: 60px;
            font-weight: 500;
        }
        .p-text-intro{
            font-size: 30px;
            line-height: 42px;
            margin-top: 6px;
            img{
                width: 14px;
                margin-left: 20px;
            }
        }
    }
}
</style>
